import { makeApiRequest } from '@/src/lib/api-request'
import { useQuery } from '@tanstack/react-query'

interface Industry {
  id: string
  catagory: string
  is_Delete: number
}

export const useIndustryQuery = () => {
  return useQuery({
    queryKey: ['industry'],
    queryFn: async () => {
      const response = await makeApiRequest({
        method: 'GET',
        url: '/MasterData/getBusinessCatagory',
        isAuthenticated: false,
        fallbackError: 'Error while fetching industries',
        data: {},
        isV3Api: true,
      })

      const data: Industry[] = response.response
      return data as Industry[]
    },
    refetchOnWindowFocus: false,
  })
}
